(() => {
  if (customElements.get('kc-recent-products')) return;
  const key = 'kc:recent:v1';
  const valid = value => value && /^[a-z0-9][a-z0-9-]*$/.test(value.handle) && Number.isFinite(value.time) && Date.now() - value.time < 30 * 86400000;
  const read = () => { try { const data = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(data) ? data.filter(valid).slice(0,12) : []; } catch { return []; } };
  const write = data => { try { localStorage.setItem(key, JSON.stringify(data)); } catch {} };
  customElements.define('kc-recent-products', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.cancelled = false;
      this.controller = new AbortController();
      this.remember = () => {
        const handle = this.dataset.handle;
        if (!handle) return;
        const variant = new URL(location.href).searchParams.get('variant') || this.dataset.variant;
        write([{handle, variant: /^\d+$/.test(variant || '') ? variant : '', time:Date.now()}, ...read().filter(item => item.handle !== handle)].slice(0,12));
      };
      this.remember();
      window.addEventListener('pagehide', this.remember);
      this.querySelector('[data-clear]').addEventListener('click', () => {
        this.cancelled = true;
        this.controller.abort();
        write([]);
        window.removeEventListener('pagehide', this.remember);
        this.hidden = true;
        this.querySelector('.kc-recent__items').replaceChildren();
      });
      this.timer = setTimeout(() => this.load(), 250);
    }
    disconnectedCallback() {
      this.cancelled = true;
      clearTimeout(this.timer);
      this.controller.abort();
      window.removeEventListener('pagehide', this.remember);
    }
    async load() {
      const items = read().filter(item => item.handle !== this.dataset.handle).slice(0,6);
      const cards = new Array(items.length);
      let next = 0;
      const worker = async () => {
        while (next < items.length && !this.cancelled) {
          const index = next++, item = items[index];
          try {
            const url = new URL((this.dataset.root || '/').replace(/\/?$/, '/') + 'products/' + item.handle, location.origin);
            url.searchParams.set('section_id','kc-recent-card');
            if (item.variant) url.searchParams.set('variant',item.variant);
            const response = await fetch(url, {signal:this.controller.signal});
            if (!response.ok) continue;
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const card = doc.querySelector('kc-product-card');
            if (card) cards[index] = card;
          } catch {}
        }
      };
      await Promise.all([worker(),worker()]);
      if (this.cancelled || !this.isConnected) return;
      const list = this.querySelector('.kc-recent__items');
      cards.filter(Boolean).forEach(card => {
        const holder = document.createElement('div');
        holder.setAttribute('role','listitem');
        holder.append(card);
        list.append(holder);
      });
      this.hidden = !list.children.length;
    }
  });
})();